import { render, staticRenderFns } from "./QuizList.vue?vue&type=template&id=2b300804&scoped=true&"
import script from "./QuizList.vue?vue&type=script&lang=js&"
export * from "./QuizList.vue?vue&type=script&lang=js&"
import style0 from "./QuizList.vue?vue&type=style&index=0&id=2b300804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b300804",
  null
  
)

export default component.exports